import Cookies from "js-cookie";

function getPreservedData() {
  const cookie = Cookies.get("instance");
  if (cookie) {
    return JSON.parse(cookie);
  }
  return null;
}

export const initialState = {
  user: getPreservedData()?.user || null,
  minigames: [],
  gameId: getPreservedData()?.gameId || null,
  gamesProgress: {},
  activeGameId: "",
  progress: {},
  score: null,
  startTimer: false,
  showTutorialSteps: true,
};

export function CREATE_USER(nextState, { user }) {
  nextState.user = user;
  nextState.minigames = [];
  nextState.activeGameId = "";
  nextState.gameId = null;
  nextState.gamesProgress = [];
  nextState.showTutorialSteps = true;
}

export function SET_GAMES(nextState, { games, gameId }) {
  nextState.minigames = games;
  nextState.gameId = gameId;
  nextState.activeGameId = games[0].uid;
  nextState.startTimer = false;
}

export function GET_GAMES_PROGRESS(nextState, { gamesProgress }) {
  nextState.gamesProgress = gamesProgress;
}

export function SET_ACTIVE_GAME(nextState, { uid }) {
  nextState.activeGameId = uid;
}

export function RECORD_PROGRESS(nextState, { gameGuid, progress }) {
  nextState.progress[gameGuid] = progress;
}

export function SET_SCORE(nextState, { score }) {
  nextState.score = score;
  nextState.gameId = null;
  nextState.user = getPreservedData()?.user;
}

export function RESET_PROGRESS(nextState) {
  nextState.progress = {};
  nextState.score = null;
  nextState.minigames = [];
  nextState.gameId = null;
  nextState.showTutorialSteps = false;
}

export function START_TIMER(nextState) {
  nextState.startTimer = true;
}
